import type { Components, Theme } from "@mui/material";

export const dialogContentTheme: Components<Theme>["MuiDialogContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0, 4),
    }),
  },
};
